module.exports = __webpack_public_path__ + "static/img/6.54f6f08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/6.png
// module id = mkvN
// module chunks = 0